import { useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
} from '@material-ui/core';

import { GET_PLATFORM_STATS } from '../../graphql/query/statistics';
import StatsChart from './StatsChart';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    boxSizing: 'border-box',
    overflowY: 'auto',
    maxHeight: `calc(100vh - ${theme.spacing(8)}px)`,
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  tile: {
    height: '100%',
  },
  tileLabel: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: 12,
    letterSpacing: 1,
  },
  tileValue: {
    marginTop: theme.spacing(1),
    fontSize: 36,
    fontWeight: 600,
  },
  chartsRow: {
    marginTop: theme.spacing(3),
  },
}));

const KPI_TILES = [
  { key: 'users', label: 'Users', field: 'totalUsers' },
  { key: 'items', label: 'Items', field: 'totalItems' },
  { key: 'collections', label: 'Collections', field: 'totalCollections' },
];

const renderTileValue = (loading, error, value) => {
  if (loading) return <CircularProgress size={24} />;
  if (error || value == null) return '—';
  return value;
};

const Statistics = () => {
  const classes = useStyles();
  const { data, loading, error } = useQuery(GET_PLATFORM_STATS);
  const stats = data?.platformStats;

  return (
    <Container maxWidth="lg" className={classes.container} data-test="statistics-tab">
      <Typography variant="h4" className={classes.title}>
        Statistics
      </Typography>

      <Grid container spacing={3}>
        {KPI_TILES.map((tile) => {
          const value = stats?.[tile.field];
          const renderedValue = renderTileValue(loading, error, value);
          const dataValue = !loading && !error && value != null ? String(value) : '';
          return (
            <Grid item xs={12} sm={4} key={tile.key}>
              <Card
                className={classes.tile}
                data-test="kpi-tile"
                data-kpi={tile.key}
                data-value={dataValue}
              >
                <CardContent>
                  <Typography className={classes.tileLabel}>{tile.label}</Typography>
                  <div className={classes.tileValue}>{renderedValue}</div>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Grid container spacing={3} className={classes.chartsRow}>
        <Grid item xs={12} md={6}>
          <StatsChart title="Registrations over time" entity="USERS" chartId="registrations" />
        </Grid>
        <Grid item xs={12} md={6}>
          <StatsChart title="Items over time" entity="ITEMS" chartId="items" />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Statistics;
